import React from 'react';
import { Chip } from '@mui/material';

import { OfferStatusType } from '../../types';
import { formatDateTime } from '../../utils/parsing';
import { getOfferPriceText } from '../../utils/offerUtils';
// import { COLOR_NEW_BLUE, COLOR_TEAL } from '../../theme';

function getOfferStatusColor(status: OfferStatusType) {
    switch (status) {
        case 'ACCEPTED':
            return 'primary';

        case 'REJECTED':
            return 'error';

        case 'EXPIRED':
            return 'error';

        case 'PENDING':
            return 'default';

        default:
            return 'default';
    }
}

function getOfferStatusText({ status, expiresAt, rejectedAt }: {
    status: OfferStatusType;
    expiresAt: string | null;
    rejectedAt: string | null;
}) {
    switch (status) {
        case 'ACCEPTED':
            return 'Accepterat';

        case 'REJECTED':
            return `Avböjt ${formatDateTime(rejectedAt)}`;

        case 'EXPIRED':
            return `Utlöpt ${formatDateTime(expiresAt)}`;

        case 'PENDING':
            return expiresAt
                ? `Besvaras senast ${formatDateTime(expiresAt)}`
                : 'Gäller tillsvidare';

        default:
            return '-';
    }
}

export function OfferStatusChip({
    price,
    status,
    expiresAt,
    rejectedAt
}: {
    price: number | null;
    status: OfferStatusType;
    expiresAt: string | null;
    rejectedAt: string | null;
}) {
    return !price ? null : (
        <Chip
            color={getOfferStatusColor(status)}
            label={getOfferStatusText({ status, expiresAt, rejectedAt })}
        />
    );
}

export function OfferPriceChip({
    price,
    listPrice = null,
    isOwnOffer = false
}: {
    price: number | null;
    listPrice?: number | null;
    isOwnOffer?: boolean;
}) {
    const label = getOfferPriceText({
        price,
        listPrice,
        isOwnOffer
    });

    if (!price && !listPrice) {
        return (
            <Chip
                label={label}
                color="default"
            />
        );
    }

    return isOwnOffer
        ? (
            <Chip
                label={label}
                color="secondary"
            />
        ) : (
            <Chip
                label={label}
                color="job"
            />
        );
}
